import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import css from '../../css/group/room.module.scss';
import { ReactComponent as ArrowDown } from '../../img/common/arrowDown.svg';
import { ReactComponent as ArrowRight } from '../../img/common/arrowRight.svg';
import { ReactComponent as Lock } from '../../img/common/lock.svg';
import { ChatGroup } from '../../model/chatGroup';
import { ChatGroupRoom } from '../../model/chatGroupRoom';
import { selectChatGroup } from '../../slice/chatGroupSlice';
import { selectVoiceCall } from '../../slice/voiceCallSlice';
import { JoinPopup } from '../common/joinPopup';

type RoomComponentProps = {
    group: ChatGroup;
    room: ChatGroupRoom;
};

export const Room: React.FC<RoomComponentProps> = (props) => {
    const [membersIsOpen, setMembersIsOpen] = useState(false);

    const { selectedChatRoom } = useSelector(selectChatGroup);
    const roomId = props.room.id;
    useEffect(() => {
        if (selectedChatRoom?.id === roomId) {
            setMembersIsOpen(true);
        } else {
            setMembersIsOpen(false);
        }
    }, [selectedChatRoom, roomId]);

    const { room } = useSelector(selectVoiceCall);

    const history = useHistory();

    return (
        <div className={css.room}>
            <div className={css.name}>
                <span className={css.nameGroup}>
                    <p>{props.room.name}</p>
                    {props.room.isLock && (
                        <Lock height={16} width={16} fill={'#F6C359'} role="img" aria-label="ロック" />
                    )}
                </span>
                {room?.id === props.room.id ? (
                    <span
                        className={css.joinButton}
                        onClick={() => history.push(`/groups/${props.group.id}/rooms/${props.room.id}`)}
                        style={{ backgroundColor: '#F14D38' }}
                    >
                        通話に戻る
                    </span>
                ) : (
                    <JoinPopup
                        group={props.group}
                        room={props.room}
                        trigger={
                            <span className={css.joinButton} style={{ backgroundColor: '#48D040' }}>
                                通話に入る
                            </span>
                        }
                    />
                )}
            </div>
            <div className={css.expandButton} onClick={() => setMembersIsOpen(!membersIsOpen)}>
                {membersIsOpen ? (
                    <ArrowDown width="16" height="16" fill="#212121" role="img" aria-label="メンバー一覧を閉じる" />
                ) : (
                    <ArrowRight height="16" width="16" fill="#212121" role="img" aria-label="メンバー一覧を開く" />
                )}
                <p>{props.room.members.length}人通話中</p>
            </div>
            {membersIsOpen && (
                <ul>
                    {props.room.members.map((member, idx) => {
                        return (
                            <li key={idx}>
                                <img src={member.icon} alt="" />
                                <span>{member.name}</span>
                            </li>
                        );
                    })}
                </ul>
            )}
            <hr />
        </div>
    );
};
